/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BigClock_Application_Features_Journal_Dtos_FailuresOverviewDto } from '../models/BigClock_Application_Features_Journal_Dtos_FailuresOverviewDto';
import type { BigClock_Application_Features_Journal_Dtos_SystemJournalDto } from '../models/BigClock_Application_Features_Journal_Dtos_SystemJournalDto';
import type { BigClock_Application_Features_Journal_Dtos_UserActionDto } from '../models/BigClock_Application_Features_Journal_Dtos_UserActionDto';
import type { BigClock_Application_Features_StationConfig_Dtos_StationConfigDto } from '../models/BigClock_Application_Features_StationConfig_Dtos_StationConfigDto';
import type { BigClock_Application_Features_StationConfig_Dtos_StationConfigExportDto } from '../models/BigClock_Application_Features_StationConfig_Dtos_StationConfigExportDto';
import type { BigClock_Application_Features_StationConfig_Dtos_StationConfigItemDto } from '../models/BigClock_Application_Features_StationConfig_Dtos_StationConfigItemDto';
import type { BigClock_Application_Features_StationConfig_Dtos_StationReadResultDto } from '../models/BigClock_Application_Features_StationConfig_Dtos_StationReadResultDto';
import type { BigClock_Application_Features_StationConfig_Dtos_StationTransferPlanDto } from '../models/BigClock_Application_Features_StationConfig_Dtos_StationTransferPlanDto';
import type { BigClock_Application_Features_StationConfig_Dtos_StationTransferRequestDto } from '../models/BigClock_Application_Features_StationConfig_Dtos_StationTransferRequestDto';
import type { BigClock_Application_Features_StationConfig_Dtos_StationTransferResultDto } from '../models/BigClock_Application_Features_StationConfig_Dtos_StationTransferResultDto';
import type { BigClock_Application_Features_StationConfig_Dtos_StationWifiPasswordDto } from '../models/BigClock_Application_Features_StationConfig_Dtos_StationWifiPasswordDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class JournalService {
    /**
     * @param controlBlockId
     * @param from
     * @param to
     * @param limit
     * @returns BigClock_Application_Features_Journal_Dtos_UserActionDto Success
     * @throws ApiError
     */
    public static getApiJournalActions(
        controlBlockId: string,
        from?: string,
        to?: string,
        limit?: number,
    ): CancelablePromise<Array<BigClock_Application_Features_Journal_Dtos_UserActionDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Journal/{controlBlockId}/actions',
            path: {
                'controlBlockId': controlBlockId,
            },
            query: {
                'from': from,
                'to': to,
                'limit': limit,
            },
        });
    }
    /**
     * @param controlBlockId
     * @param from
     * @param to
     * @returns BigClock_Application_Features_Journal_Dtos_SystemJournalDto Success
     * @throws ApiError
     */
    public static getApiJournalSystem(
        controlBlockId: string,
        from?: string,
        to?: string,
    ): CancelablePromise<BigClock_Application_Features_Journal_Dtos_SystemJournalDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Journal/{controlBlockId}/system',
            path: {
                'controlBlockId': controlBlockId,
            },
            query: {
                'from': from,
                'to': to,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }
    /**
     * @param period
     * @param refresh
     * @returns BigClock_Application_Features_Journal_Dtos_FailuresOverviewDto Success
     * @throws ApiError
     */
    public static getApiJournalFailures(
        period?: string,
        refresh?: boolean,
    ): CancelablePromise<BigClock_Application_Features_Journal_Dtos_FailuresOverviewDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Journal/failures',
            query: {
                'period': period,
                'refresh': refresh,
            },
        });
    }
    /**
     * @param controlBlockId
     * @param at
     * @returns BigClock_Application_Features_StationConfig_Dtos_StationConfigDto Success
     * @throws ApiError
     */
    public static getApiJournalConfig(
        controlBlockId: string,
        at?: string,
    ): CancelablePromise<BigClock_Application_Features_StationConfig_Dtos_StationConfigDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Journal/{controlBlockId}/config',
            path: {
                'controlBlockId': controlBlockId,
            },
            query: {
                'at': at,
            },
        });
    }
    /**
     * @param controlBlockId
     * @param settingKey
     * @param deviceId
     * @param limit
     * @returns BigClock_Application_Features_StationConfig_Dtos_StationConfigItemDto Success
     * @throws ApiError
     */
    public static getApiJournalConfigHistory(
        controlBlockId: string,
        settingKey?: string,
        deviceId?: string,
        limit?: number,
    ): CancelablePromise<Array<BigClock_Application_Features_StationConfig_Dtos_StationConfigItemDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Journal/{controlBlockId}/config/history',
            path: {
                'controlBlockId': controlBlockId,
            },
            query: {
                'settingKey': settingKey,
                'deviceId': deviceId,
                'limit': limit,
            },
        });
    }
    /**
     * @param controlBlockId
     * @param recordId
     * @param kind
     * @returns BigClock_Application_Features_StationConfig_Dtos_StationWifiPasswordDto Success
     * @throws ApiError
     */
    public static getApiJournalConfigWifiPassword(
        controlBlockId: string,
        recordId?: string,
        kind?: string,
    ): CancelablePromise<BigClock_Application_Features_StationConfig_Dtos_StationWifiPasswordDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Journal/{controlBlockId}/config/wifi-password',
            path: {
                'controlBlockId': controlBlockId,
            },
            query: {
                'recordId': recordId,
                'kind': kind,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }
    /**
     * @param controlBlockId
     * @returns BigClock_Application_Features_StationConfig_Dtos_StationReadResultDto Success
     * @throws ApiError
     */
    public static postApiJournalConfigRead(
        controlBlockId: string,
    ): CancelablePromise<Array<BigClock_Application_Features_StationConfig_Dtos_StationReadResultDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Journal/{controlBlockId}/config/read',
            path: {
                'controlBlockId': controlBlockId,
            },
        });
    }
    /**
     * @param controlBlockId
     * @param at
     * @returns BigClock_Application_Features_StationConfig_Dtos_StationConfigExportDto Success
     * @throws ApiError
     */
    public static getApiJournalConfigExport(
        controlBlockId: string,
        at?: string,
    ): CancelablePromise<BigClock_Application_Features_StationConfig_Dtos_StationConfigExportDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Journal/{controlBlockId}/config/export',
            path: {
                'controlBlockId': controlBlockId,
            },
            query: {
                'at': at,
            },
        });
    }
    /**
     * @param controlBlockId
     * @param sourceId
     * @returns BigClock_Application_Features_StationConfig_Dtos_StationTransferPlanDto Success
     * @throws ApiError
     */
    public static getApiJournalConfigTransfer(
        controlBlockId: string,
        sourceId?: string,
    ): CancelablePromise<BigClock_Application_Features_StationConfig_Dtos_StationTransferPlanDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Journal/{controlBlockId}/config/transfer',
            path: {
                'controlBlockId': controlBlockId,
            },
            query: {
                'sourceId': sourceId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param controlBlockId
     * @param requestBody
     * @returns BigClock_Application_Features_StationConfig_Dtos_StationTransferResultDto Success
     * @throws ApiError
     */
    public static postApiJournalConfigTransfer(
        controlBlockId: string,
        requestBody?: BigClock_Application_Features_StationConfig_Dtos_StationTransferRequestDto,
    ): CancelablePromise<BigClock_Application_Features_StationConfig_Dtos_StationTransferResultDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Journal/{controlBlockId}/config/transfer',
            path: {
                'controlBlockId': controlBlockId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
